import { read_api_error } from './api_error_message';

// apis impersonate_myt_user refusal codes (cms/impersonation_access.ts) and what the CMS user should read.
const REFUSAL_TEXT = {
  CMS_USER_INACTIVE: 'Your CMS account is inactive, so it cannot impersonate users.',
  CMS_USER_NO_ACCESS: 'Your CMS account has no access, so it cannot impersonate users.',
  CMS_USER_NOT_FOUND: 'Your CMS account was not found, so it cannot impersonate users.'
};
const DEFAULT_REFUSAL_TEXT = 'Your CMS account is not allowed to impersonate users.';

// The readable line for a 403 from the impersonation mint, or null when the error is anything else.
export const impersonation_refusal_text = (e) => {
  if (e?.response?.status !== 403) return null;
  const { code, message } = read_api_error(e);
  return REFUSAL_TEXT[code] || message || DEFAULT_REFUSAL_TEXT;
};
